export default __webpack_public_path__ + "static/media/materialize-4.e709c93c.jpg";